import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const userStaticData = {
  menuTitle: MenuTitle.User
};
export const Route = createFileRoute('/_private-routes/user')({
  staticData: userStaticData
});
